import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Mountain, Sparkles } from "lucide-react";

// Global upgrade prompt: opens whenever an axios call returns a Premium-feature 403.
// Listens for a `mm:upgrade-prompt` event we dispatch from the api interceptor.
export const UpgradeModal = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const onPrompt = (e) => {
      setMessage(e.detail?.message || "This is a Premium feature. Upgrade to keep climbing.");
      setOpen(true);
    };
    window.addEventListener("mm:upgrade-prompt", onPrompt);
    return () => window.removeEventListener("mm:upgrade-prompt", onPrompt);
  }, []);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[70] bg-mm-navy/50 backdrop-blur-sm flex items-center justify-center px-4" data-testid="upgrade-modal" onClick={() => setOpen(false)}>
      <div className="bg-white rounded-2xl max-w-md w-full p-7 relative" onClick={(e) => e.stopPropagation()}>
        <button
          onClick={() => setOpen(false)}
          className="absolute top-3 right-3 text-mm-navy/60 hover:text-mm-navy"
          aria-label="Close"
          data-testid="upgrade-modal-close"
        ><X size={20} strokeWidth={2.5} /></button>
        <div className="w-12 h-12 rounded-xl bg-mm-gold/20 text-mm-gold flex items-center justify-center mb-4">
          <Mountain size={24} strokeWidth={2.5} />
        </div>
        <div className="text-xs uppercase tracking-[0.22em] font-bold text-mm-steel">Higher ground</div>
        <h3 className="font-heading text-2xl font-black text-mm-navy mt-1">Premium feature ahead</h3>
        <p className="text-mm-navy/75 mt-3">{message}</p>
        <div className="mt-5 rounded-xl bg-mm-parchment border border-mm-navy/10 p-4">
          <div className="flex items-baseline gap-2">
            <div className="font-heading text-3xl font-black text-mm-navy">$5</div>
            <div className="text-mm-navy/60">/ month</div>
            <div className="text-xs uppercase tracking-widest font-bold text-mm-gold ml-auto">or $45/yr</div>
          </div>
          <ul className="mt-3 space-y-1 text-sm text-mm-navy/80">
            <li>• Unlimited expeditions</li>
            <li>• Rescue Route & Explorer's Challenge</li>
            <li>• Full badge collection</li>
          </ul>
        </div>
        <Link
          to="/pricing"
          onClick={() => setOpen(false)}
          className="btn-trail btn-gold w-full mt-5"
          data-testid="upgrade-modal-cta"
        >
          <Sparkles size={16} strokeWidth={2.5} /> Reach the summit
        </Link>
        <button onClick={() => setOpen(false)} className="mt-3 w-full text-sm text-mm-navy/60 hover:text-mm-navy" data-testid="upgrade-modal-dismiss">
          Not right now
        </button>
      </div>
    </div>
  );
};

export default UpgradeModal;
